<template>
  <div>
    <div class="review--item">
      <div class="review--content">
        <span>Currency</span>

        <div class="review--row">
          <div :class="`icon icon__${line.currency.code.toLowerCase()}`"></div>

          <div class="review--currency">
            <div class="code">{{ line.currency.code }}</div>
            <p class="label">({{ line.currency.pluralName }})</p>
          </div>
        </div>
      </div>
      <div class="review--quantity">
        <span>Amount</span>

        <div class="input_container" tabindex="-1">
          <div class="Currency-Code">
            <small class="currency-code" v-html="line.currency.symbol"></small>
          </div>
          <quantity :value="line" />
        </div>
      </div>

      <div class="review--units">
        <span>Rounded up to the nearest</span>
        <div><strong>{{`${line.currency.symbol}${currencyRate.increment}`}}</strong></div>
      </div>

      <div class="review--content">
        <span>{{ rateLabel }}</span>
        <strong>{{ line.rate | rate }}</strong>
      </div>

      <div class="review--content">
        <span v-if="shoppingCart.product.id !== 3">Cost</span>
        <span v-else>You will receive</span>
        <strong>{{ line.total | price }}</strong>
      </div>

      <div class="review--delete">
        <button class="close" @click="deleteLine(line.id)"></button>
      </div>
    </div>
    <tiered-message  v-if="shoppingCart.product.id !== 3 " :quantity="line.qty"  :CurrencyRate="currencyRate" :line="line.currency"  @boostRate="boostRate" />
    <div class="notification currency-restriction" v-if="restrictions.length && shoppingCart.product.id !== 3">
      <p v-for="(restriction, index) in restrictions" :key="index">
        {{ restriction.message }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Quantity from '@vue/common/components/quantity'
import TieredMessage from './checkout-tiered-message'
import { getRate, mapRateDetailToLegacyFormat } from '@vue/services/api/currency.api'
import { getStoreConfiguration } from '@vue/services/api/store.api';
import { ProductTypes } from '@vue/common/constants/productTypes'

export default {
  name: 'ReviewItem',
  props: ['line'],
  data() {
    return {
      currencyRate: {
        rate: null,
        price: null,
        increment: null
      }
    }
  },
  components: {
    Quantity,
    TieredMessage,
  },
  computed: {
    ...mapState({
      currencies: (state) => state.currency.currencies,
      shoppingCart: (state) => state.cart.shoppingCart,
      storeId: (state) => state.cart.shoppingCart.store.id,
      store: (state) => state.store,
      content: (state) => state.checkout.content,
      isSignedInToLoyalty: (state) => state.cart.isSignedInToLoyalty
    }),
    restrictions: function () {
      const currency = this.currencies.find(
        (r) => r.code === this.line.currency.code
      )

      if (!currency) {
        return []
      }

      return currency.currencyRestrictions
    },
    rateLabel: function () {
      return this.isSignedInToLoyalty ? (this.content.loyaltyRateLabel || "Loyalty Rate") : (this.content.standardRateLabel || "Rate" );
    }
  },
  methods: {
    ...mapActions({
      deleteLine: 'cart/deleteLine',
      updateLine: 'cart/updateLine',
      getCalculatorContent: 'calculator/getCalculatorContent'
    }),
    boostRate(value) {
      this.updateLine({
        id: this.line.id,
        code: this.line.currency.code,
        quantity: value.target,
      })
    },

    async getCurrencyRate() {
      const rateResponse = await getRate({ transactionType: this.shoppingCart.product.transactionType, 
                                                    currency: this.line.currency.code });
      
      const mappedRateData = mapRateDetailToLegacyFormat(rateResponse.data);

      const branchCode = this.shoppingCart.product.id === ProductTypes.HOME_DELIVERY
        ? this.store.defaultStore.branchCode
        : this.shoppingCart.store?.branchCode || this.store.defaultStore?.branchCode;

      const storeConfigResponse = await getStoreConfiguration({ code: branchCode, 
                                                                transactionType: this.shoppingCart.product.transactionType, 
                                                                currencyCode: this.line.currency.code });
      const increment = storeConfigResponse?.data?.increment;

      this.currencyRate = { ...mappedRateData, increment };
    },

  },
  async mounted() {
    await this.getCalculatorContent();
    await this.getCurrencyRate();
  },
}
</script>
